<template>
  <div class="exam-uniform-batch-exam-subject-title">
    <div class="title">{{getTitle}}</div>
  </div>
</template>

<script>
export default {
  name: 'ExamUniformBatchExamSubjectTitle',
  props: {
    grid: {
      type: Object,
      required: true
    },
    title: String
  },
  computed: {
    getTitle () {
      if (this.grid.data && this.grid.data.raw) {
        const attached = this.grid.data.raw.attached
        if (attached) {
          return `${this.title} - ${attached.batch}`
        }
      }
      return this.title
    }
  }
}
</script>
